import { render, staticRenderFns } from "./anlitable.vue?vue&type=template&id=58b0b16b&scoped=true"
import script from "./anlitable.vue?vue&type=script&lang=js"
export * from "./anlitable.vue?vue&type=script&lang=js"
import style0 from "./anlitable.vue?vue&type=style&index=0&id=58b0b16b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b0b16b",
  null
  
)

export default component.exports